class LWGrid extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    static get observedAttributes() {
        return ['gap', 'min-width', 'cols-mobile', 'cols-desktop'];
    }

    attributeChangedCallback() {
        this.render();
    }

    render() {
        const gap = this.getAttribute('gap') || '20px';
        const minWidth = this.getAttribute('min-width') || '300px';
        const colsMobile = this.getAttribute('cols-mobile') || '1';
        const colsDesktop = this.getAttribute('cols-desktop') || 'auto';

        // Bepaal de grid-template voor desktop
        // Als cols-desktop 'auto' is, gebruiken we jouw oude minmax systeem
        const desktopGrid = colsDesktop === 'auto' 
            ? `repeat(auto-fill, minmax(${minWidth}, 1fr))` 
            : `repeat(${colsDesktop}, 1fr)`;

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                width: 100%;
            }

            .grid {
                display: grid;
                grid-template-columns: ${desktopGrid};
                gap: ${gap};
            }

            @media (max-width: 600px) {
                .grid {
                    gap: 15px;
                    /* Forceer het aantal kolommen op mobiel */
                    grid-template-columns: repeat(${colsMobile}, 1fr);
                }
            }

            ::slotted(*) {
                height: 100%;
            }
        </style>

        <div class="grid">
            <slot></slot>
        </div>
        `;
    }
}

customElements.define('lw-grid', LWGrid);